
import { CommonService } from '@/services'
import { Component, Vue, Ref } from 'vue-property-decorator'
import ScrollTo from '@/components/scroll_to/index.vue'
import ScrollToType from '@/components/scroll_to/type'
import TableList from '../components/bulletin/table.vue'

@Component({
    name: 'bulletin-list',
    components: {
        ScrollTo,
        TableList
    }
})
export default class extends Vue {
    @Ref('scrollRef') private scrollEl!: ScrollToType
    private pageSize = 15
    private pageIndex = 1
    private pageTotal = 0
    private list: any[] = []
    private isLoading = true

    private mounted() {
        this.getList()   
    }

    /** 获取公告栏列表 */
    private async getList() {
        this.isLoading = true
        const params = {
            page_index: this.pageIndex,
            page_size: this.pageSize
        }
        const result = await CommonService.getBulletinList(params)
        if (result.status === 200) {
            this.pageTotal = result.data.page_total
            this.list = result.data.list
        }
        this.isLoading = false
    }

    /** 删除公告 */
    private async deleteBulletin(bulletin: any) {
        const params = { id: bulletin.id }
        const result = await CommonService.deleteBulletin(params)
        if (result.status === 200) {
            this.list.splice(this.list.indexOf(bulletin), 1)
            --this.pageTotal
            this.$message({
                type: 'success',
                message: '删除成功',
                showClose: true
            })
            return
        }
        this.$message({
            type: 'error',
            message: result.message || '发生错误, 请稍后再试',
            showClose: true
        })
    }

    // 分页
    private onPageChange(curPage: number) {
        this.pageIndex = curPage
        this.scrollEl.scrollToTop(this.getList)
    }

    // 删除 
    private onDelete(bulletin: any) {
        this.$confirm('你正在删除公告, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            this.deleteBulletin(bulletin)
        })
    }
}
